<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container pb-0">
                <div class="page-name">
                    <template v-for="(menu, index) in menu_data">
                        <template v-if="menu.name == company">
                            {{menu.name}}
                        </template>
                    </template>
                </div>
                <!--<button type="submit" v-on:click.prevent="addContact" class="btn btn-primary waves-effect pull-right">Add</button>-->
            </div>
            <div class="admin-page-content"> <!--class = "admin-page-content sidebar-right"-->
                <!--page content-->
                <!--<div class="admin-page-content">
                    <form id="contactSearchForm">
                        <div class="forms-container">
                            <div class="row no-margin">
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label" for="user_name">User :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <input v-model="user_name" class="form-control" id="user_name" placeholder="Search by User" />
                                    </div>
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-12 paddingleft0">
                                        <input id="addContactBtn" type="submit" value="Search" class="btn btn-primary pull-right" v-on:click.prevent="loadContacts()">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>-->
                <div class="internal-container contact-container">
                    <div class="contacts-list-container">
                        <template v-for="(menu, index) in menu_data">
                            <template v-if="menu.name == company">
                                <template v-for="(location, index1) in menu.locations">
                                    <template v-if="location.department_count > 0">
                                        <div class="contacts-block" v-on:click.prevent="gotoDepartmentList(company,location.id)">
                                            <div class="contact-locations" :title="location.name">{{stringTrim(location.name,18)}} <span v-if="windowWidth > 767" title="Click to view details" :class="'pull-right contact-info-btn color-9cadb5 info_btn_location_'+location.id" v-on:click.stop.prevent="changelocationId(location.id)" ><i class="fa fa-info"></i></span></div>
                                            <div class="contact-details">{{location.address_line}}</div>
                                            <div class="contact-phone">
                                                <template v-if="location.contacts.length > 0">
                                                    <template v-if="location.contacts[0].contact_label != ''">
                                                        {{location.contacts[0].contact_label}} : </template>
                                                    <template v-if="location.contacts[0].contact != ''"><strong>{{location.contacts[0].contact}}</strong></template>
                                                </template>
                                            </div>
                                            <div v-if="windowWidth <= 767">
                                                <!--<div class="sidebar-locations">{{location.name}}</div>-->
                                                <template v-if="location.note != '' || location.address_line != '' || location.contacts.length > 0">
                                                    <!--<div v-if="location.address_line != ''" class="sidebar-locations-details">
                                                        <img src="/static/images/map-pin.png">
                                                        {{location.address_line}}
                                                    </div>-->
                                                    <!--<template v-if="location.contacts.length > 0">
                                                        <div class="primary-contact">
                                                            <p v-show="location.contacts[0].contact_label != ''">
                                                                {{location.contacts[0].contact_label}} :
                                                            </p> <strong>{{location.contacts[0].contact}}</strong>
                                                        </div>
                                                    </template>-->
                                                    <template v-if="location.contacts.length > 1">
                                                        <template v-for="(cont, index2) in location.contacts">
                                                            <template v-if="index2 != 0">
                                                                <div class="sidebar-locations-details mt-0 mb-0">
                                                                    <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                                                    {{cont.contact}}
                                                                </div>                                    
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <div v-if="location.note != ''" class="sidebar-locations-details mt-0 mb-0">
                                                        Note : {{location.note}}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="sidebar-locations-details mt-0 mb-0">
                                                        {{noDataMessaage}}
                                                    </div>    
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="contacts-block">
                                            <div class="contact-locations" :title="location.name">{{stringTrim(location.name,18)}} <span v-if="windowWidth > 767" title="Click to view details" :class="'pull-right contact-info-btn color-9cadb5 info_btn_location_'+location.id" v-on:click.stop.prevent="changelocationId(location.id)" ><i class="fa fa-info"></i></span></div>
                                            <div class="contact-details">{{location.address_line}}</div>
                                            <div class="contact-phone">
                                                <template v-if="location.contacts.length > 0">
                                                    <template v-if="location.contacts[0].contact_label != ''">
                                                        {{location.contacts[0].contact_label}} : </template>
                                                    <template v-if="location.contacts[0].contact != ''"><strong>{{location.contacts[0].contact}}</strong></template>
                                                </template>
                                            </div>
                                            <div v-if="windowWidth <= 767">
                                                <!--<div class="sidebar-locations">{{location.name}}</div>-->
                                                <template v-if="location.note != '' || location.address_line != '' || location.contacts.length > 0">
                                                    <!--<div v-if="location.address_line != ''" class="sidebar-locations-details">
                                                        <img src="/static/images/map-pin.png">
                                                        {{location.address_line}}
                                                    </div>-->
                                                    <!--<template v-if="location.contacts.length > 0">
                                                        <div class="primary-contact">
                                                            <p v-show="location.contacts[0].contact_label != ''">
                                                                {{location.contacts[0].contact_label}} :
                                                            </p> <strong>{{location.contacts[0].contact}}</strong>
                                                        </div>
                                                    </template>-->
                                                    <template v-if="location.contacts.length > 1">
                                                        <template v-for="(cont, index2) in location.contacts">
                                                            <template v-if="index2 != 0">
                                                                <div class="sidebar-locations-details mt-0 mb-0">
                                                                    <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                                                    {{cont.contact}}
                                                                </div>                                    
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <div v-if="location.note != ''" class="sidebar-locations-details mt-0 mb-0">
                                                        Note : {{location.note}}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="sidebar-locations-details mt-0 mb-0">
                                                        {{noDataMessaage}}
                                                    </div>    
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
            <!--page content-->
            <div class="page-sidebar" v-if="windowWidth > 767">
                <div class="contactInfoBtn" v-on:click.prevent="showContact(company, locationId)" >
                    <i class="openCloseBtn fa fa-caret-right"></i>
                </div>
                <div class="contactDetails">
                    <template v-for="(menu, index) in menu_data">
                        <template v-if="menu.name == company">
                            <template v-for="(location, index1) in menu.locations">
                                <template v-if="location.id == locationId">
                                    <div class="sidebar-locations">{{location.name}}</div>
                                    <template v-if="location.note != '' || location.address_line != '' || location.contacts.length > 0">
                                        <div v-if="location.address_line != ''" class="sidebar-locations-details">
                                            <img src="/static/images/map-pin.png">
                                            {{location.address_line}}
                                        </div>
                                        <div v-if="location.note != ''" class="sidebar-locations-details mt-0">
                                            Note : {{location.note}}
                                        </div>
                                        <template v-if="location.contacts.length > 0">
                                            <div class="primary-contact">
                                                <p v-show="location.contacts[0].contact_label != ''">
                                                    {{location.contacts[0].contact_label}} :
                                                </p> <strong>{{location.contacts[0].contact}}</strong>
                                            </div>
                                        </template>
                                        <template v-if="location.contacts.length > 1">
                                            <ul>
                                                <template v-for="(cont, index2) in location.contacts">
                                                    <template v-if="index2 != 0">
                                                        <li>
                                                            <span v-if="cont.contact_label != ''">{{cont.contact_label}} :</span>
                                                            {{cont.contact}}
                                                        </li>                                    
                                                    </template>
                                                </template>
                                            </ul>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <div class="sidebar-locations-details">
                                            {{noDataMessaage}}
                                        </div>    
                                    </template>
                                </template>
                            </template>
                        </template>
                    </template>
                </div>
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    import EventBus from '../../event-bus';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    var self;
    export default {
        name: 'ListBenefits',
        components: {
            'app-backend-footer': BackendFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                hideContactflag: false,
                noDataMessaage: 'Details not available',
                company: '',
                windowWidth: 0,
                locationId: 0,
                selected_menu_data: '',
                user_name: '',
                isShowLoggedinfields: true,
                userPermissions: ['add_contact_extension'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                sitesArr: [],
                firstLoad: 0,
                columns: [
                    {
                        label: 'User',
                        field: 'user',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "User", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact',
                        field: 'contact',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Contact", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'site_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Department',
                        field: 'department_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
//                            placeholder: "MM/DD/YYYY",
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'updated_at',
                        type: 'desc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }

        },
        beforeMount: function () {
            self = this;
            self.checkLogin(window.location.href);
            var contactDetailOpen = localStorage.getItem("contact_detail_open");
            if (contactDetailOpen == 'true') {
                self.hideContactflag = false;
            } else {
                self.hideContactflag = true;
            }
            //self.checkLogin();
        },
        mounted: function () {
//            self = this;
            self.windowWidth = $(window).width();
            $(window).resize(function () {
                self.windowWidth = $(window).width();
            });
            self.company = this.$route.params.slug;
            self.getMenus();
            self.getPermissions();
            self.setWidthToContactContainer(550);
            console.log("Extension mounted");
            setTimeout(function () {
                $.each(self.menu_data, function (i) {
                    if (self.menu_data[i].name == self.company) {
                        $.each(self.menu_data[i].locations, function (j) {
                            if (self.locationId == 0) {
                                self.locationId = self.menu_data[i].locations[j].id;
                            }
                        });
                    }
                });
            }, 500);
            /*self.loadSites();*/
            /*self.loadDepartments();*/
            /*self.loadContacts();*/
            self.showContact(self.company, self.locationId, self.hideContactflag);
        },
        watch: {
            '$route'(to, from) {
                self.company = this.$route.params.slug;
                setTimeout(function () {
                    $.each(self.menu_data, function (i) {
                        if (self.menu_data[i].name == self.company) {
                            $.each(self.menu_data[i].locations, function (j) {
                                self.locationId = self.menu_data[i].locations[j].id;
                                return false;
                            });
                        }
                    });
                }, 500);
            }
        },
        methods: {
            changelocationId(location) {
                $('.contact-info-btn').removeClass('color-098de1');
                $('.contact-info-btn').addClass('color-9cadb5');
                $('.info_btn_location_' + location).removeClass('color-9cadb5');
                $('.info_btn_location_' + location).addClass('color-098de1');
                if (self.windowWidth > 767) {
                    self.locationId = location;
                }
            },
            showContact(company, location, hide) {
                hide = (hide === null || typeof (hide) === "undefined" || hide == '') ? false : hide;
                if (self.windowWidth > 767) {
                    self.locationId = location;
                }
                if (self.windowWidth > 767) {
                    $('.internal-container').addClass('openDetailview');
                } else {
                    $('.page-sidebar').hide();
                }
                if (hide) {
                    window.localStorage.setItem("contact_detail_open", false);
                    self.hideContactflag = true;
                    $('.contactDetails').fadeOut();
                    setTimeout(function () {
                        $('.page-sidebar').addClass('zeroWidth');
                        if (self.windowWidth > 767) {
                            $('.page-sidebar').show();
                            $('.internal-container').removeClass('openDetailview');
                        } else {
                            $('.page-sidebar').hide();
                        }
                        $('.openCloseBtn').removeClass('fa-caret-right');
                        $('.openCloseBtn').addClass('fa-caret-left');
                    }, 300);
                } else {
                    var classavailable = $('.page-sidebar').attr('class');
                    if (typeof (classavailable) != 'undefined') {
                        if (classavailable.indexOf("zeroWidth") > 0) {
                            window.localStorage.setItem("contact_detail_open", true);
                            self.hideContactflag = false;
                            $('.page-sidebar').removeClass('zeroWidth');
                            if (self.windowWidth > 767) {
                                $('.page-sidebar').show();
                                $('.internal-container').addClass('openDetailview');
                            } else {
                                $('.page-sidebar').hide();
                            }
                            $('.openCloseBtn').removeClass('fa-caret-left');
                            $('.openCloseBtn').addClass('fa-caret-right');
                            $('.contactDetails').fadeIn();
                        } else {
                            window.localStorage.setItem("contact_detail_open", false);
                            self.hideContactflag = true;
                            $('.contactDetails').fadeOut();
                            setTimeout(function () {
                                $('.page-sidebar').addClass('zeroWidth');
                                if (self.windowWidth > 767) {
                                    $('.page-sidebar').show();
                                    $('.internal-container').removeClass('openDetailview');
                                } else {
                                    $('.page-sidebar').hide();
                                }
                                $('.openCloseBtn').removeClass('fa-caret-right');
                                $('.openCloseBtn').addClass('fa-caret-left');
                            }, 300);
                        }
                    } else {
                        window.localStorage.setItem("contact_detail_open", true);
                        self.hideContactflag = false;
                        $('.page-sidebar').removeClass('zeroWidth');
                        if (self.windowWidth > 767) {
                            $('.page-sidebar').show();
                            $('.internal-container').addClass('openDetailview');
                        } else {
                            $('.page-sidebar').hide();
                        }
                        $('.openCloseBtn').removeClass('fa-caret-left');
                        $('.openCloseBtn').addClass('fa-caret-right');
                        $('.contactDetails').fadeIn();
                    }
                }
                self.setWidthToContactContainer(350);
            },
            gotoDepartmentList(company, location) {
                self.$router.push('/directory/extensionslist/' + company + '/' + location);
            },
            addContact() {
                self.$router.push('/backend/addcontact');
            },
            loadCompanies() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: ''
                    }
                };
                HTTP.get("ce-getcompany", config)
                        .then(function (response) {
                            self.companyArr = [];
                            $.each(response.data.content, function (i) {
                                /*self.companyArr.push(response.data.content[i].text);*/
                                self.companyArr.push(response.data.content[i]);
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadContacts();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadContacts();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('user');
                    field: ('contact');
                    field: ('site_name');
                    field: ('department_name');
                    field: ('updated_at');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.user || filters.id || filters.contact || filters.site_name || filters.department_name || filters.updated_at || filters.updated_by) {
                    self.loadContacts();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['ContactExtensionList'].selectedRows).length;
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadContacts();
            },
            loadSites() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        get_all: 1
                    }
                };
                HTTP.get("getsite", config)
                        .then(function (response) {
                            self.sitesArr = [];
                            // self.sitesArr = response.data.content;
                            $.each(response.data.content, function (i) {
                                self.sitesArr.push(response.data.content[i].text);
                            });
                            $.each(self.columns, function (i) {
                                if (self.columns[i].field == 'site_name') {
                                    self.columns[i].filterOptions.filterDropdownItems = self.sitesArr;
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadDepartments() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        get_all: 1
                    }
                };
                HTTP.get("ce-getdepartment", config)
                        .then(function (response) {
                            self.sitesArr = [];
                            // self.sitesArr = response.data.content;
                            $.each(response.data.content, function (i) {
                                self.sitesArr.push(response.data.content[i].text);
                            });
                            $.each(self.columns, function (i) {
                                if (self.columns[i].field == 'department_name') {
                                    self.columns[i].filterOptions.filterDropdownItems = self.sitesArr;
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadContacts: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort
                    }
                };
                HTTP.get('listcontact', config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }

                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                        })
            },
            deleteContact: function (id) {
                var userArr = [];
                if (id) {
                    userArr.push(id);
                } else {
                    var selectedUser = self.$refs['ContactExtensionList'].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        userArr.push(this.$refs['ContactExtensionList'].selectedRows[i].id);
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        deleteArr: userArr,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletecontact", config)
                                .then(function (response) {
                                    self.loadContacts();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                })
            },
            getFirstContact: function (contact) {
                var data;
                if (contact != null) {
                    data = (contact != '') ? JSON.parse(contact) : [{contact_label: '', contact: ''}];
                } else {
                    data = [{contact_label: '', contact: ''}];
                }
                return data;
            }

        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/contactextension/ViewLocationDepartments.vue